module.exports = __webpack_public_path__ + "img/heli.d4304d25.svg";